// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
//原型拓展
//转成树形结构
Array.prototype.toTree = function (idName = 'id',pidName = 'pid',seqName = 'seq') {
  idName = idName || 'id';
  pidName = pidName || 'pid';
  seqName = seqName || 'seq';
  var idMap = {};
  var pidMap = {};
  this.forEach(function (item) {
    var id = item[idName];
    if(id){//无id数据不处理
      idMap[id] = item;
    }
    var pid = item[pidName] || 0;
    var children = pidMap[pid];
    if(children){
      children.push(item);
    }else{
      pidMap[pid] = [item];
    }
  });
  var treeData = [];
  for(var k in pidMap) {
    var v = pidMap[k];
    if(k == 0 || !idMap[k]){
      treeData = treeData.concat(v);
    }else{
      idMap[k].children = v.sort(sortSeq);
    }
  }
  //排序
  function sortSeq(a,b) {
    return a[seqName] - b[seqName];
  }
  return treeData.sort(sortSeq);
};

